module.exports = __webpack_public_path__ + "static/media/pharmaLex.a7574d40.jpg";